export function Typing() {
  return (
    <div className="typing" aria-label="Assistant is thinking">
      <span className="typing-label">Thinking</span>
      <i />
      <i />
      <i />
    </div>
  );
}
